var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#099DFD;stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.6,140.6c9.2,13.1,24.4,21.6,41.6,21.6H166v-50.9c0-23.4-15.8-43.1-37.4-49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.2,60.4c4.7,0,9.2,0.6,13.5,1.8c-9-14.1-24.8-23.4-42.8-23.4C57.7,38.8,35,61.6,35,89.7v50.9h38.6 c-5.8-8.3-9.3-18.4-9.3-29.3C64.3,83.2,87.1,60.4,115.2,60.4z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 96,
    y1: 111.3,
    x2: 138,
    y2: 111.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 96,
    y1: 91.3,
    x2: 138,
    y2: 91.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 96,
    y1: 131.2,
    x2: 138,
    y2: 131.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconBlue);
export default __webpack_public_path__ + "static/media/chat_icon_blue.3c9c4d2a50a3a5968f36fcc98eb6ed81.svg";
export { ForwardRef as ReactComponent };